import { createI18n } from 'vue-i18n'
import { storedLocale, type Locale } from '@/composables/useStoredLocale'
import en from '@/locales/en.json'
import ru from '@/locales/ru.json'

export type { Locale }

/**
 * Русская плюрализация для строк «0 | one | few | many»: «0 филиалов |
 * {n} филиал | {n} филиала | {n} филиалов». Дефолтное правило vue-i18n
 * двухформенное (en) — числительные 2–4 и 11–14 ломаются без своего правила.
 */
export function ruPluralRule(choice: number, choicesLength: number): number {
  if (choice === 0) return 0
  const mod10 = choice % 10
  const teen = choice % 100 >= 11 && choice % 100 <= 14
  if (mod10 === 1 && !teen) return 1
  if (mod10 >= 2 && mod10 <= 4 && !teen) return 2
  return choicesLength < 4 ? 2 : 3
}

export const i18n = createI18n({
  legacy: false,
  locale: storedLocale.value,
  fallbackLocale: 'en',
  pluralRules: { ru: ruPluralRule },
  messages: { ru, en },
})
